import React, { useEffect, useState } from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from 'components/Inputs/TextField';
import 'dayjs/locale/ko';

const style = {
  '& label': {
    height: '15px',
    fontSize: 13
  },
  '& div': {
    backgroundColor: 'white'
    // '& .Mui-disabled': {
    //     backgroundColor: '#EAEAEA'
    // }
  },
  '& input': {
    height: '1.1rem',
    fontSize: 13
  },
  '& input:disabled': {
    backgroundColor: '#EAEAEA'
  }
};

export default function CustomDatePicker(props) {
  const { id, format, onChangeDate, date, sx, disabled, ...rest } = props;

  const [value, setValue] = useState(null);

  useEffect(() => {
    if (value) {
      onChangeDate(value, id);
    }
  }, [value]);

  useEffect(() => {
    if (date) setValue(date);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
      {format === 'year' && (
        <DatePicker
          views={['year']}
          // label="Year only"
          value={value}
          onChange={(newValue) => {
            setValue(newValue.format('YYYY'));
          }}
          disabled={disabled}
          renderInput={(params) => <TextField {...params} helperText={null} sx={{ ...style, ...sx }} />}
          disableMaskedInput={true}
          {...rest}
        />
      )}
      {format === 'yyyy-MM' && (
        <DatePicker
          inputFormat={'YYYY-MM'}
          views={['year', 'month']}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          onError={(value) => {
            console.log(value);
          }}
          disabled={disabled}
          renderInput={(params) => <TextField {...params} helperText={null} sx={{ ...style, ...sx }} />}
          disableMaskedInput={true}
          {...rest}
        />
      )}
      {format === 'yyyy-MM-DD' && (
        <DatePicker
          inputFormat={'YYYY-MM-DD'}
          // label="Invert the order of views"
          value={value}
          onChange={(newValue) => {
            setValue(newValue.format('YYYY-MM-DD'));
          }}
          disabled={disabled}
          renderInput={(params) => <TextField {...params} helperText={null} sx={{ ...style, ...sx }} />}
          disableMaskedInput={true}
          {...rest}
        />
      )}
    </LocalizationProvider>
  );
}
